import Api from "../api";

const VoucherModule = {
    namespaced: true,
    state: {
        vouchers: []
    },
    actions: {
        SET_VOUCHERS ({ commit }, vouchers) {
            commit('SET_VOUCHERS', vouchers);
        },
        apply ({ dispatch }, code) {
            return Api.call({
                action: 'validateVoucher',
                discount_name: code,
                t: new Date().getTime()
            }).then((data) => {
                if (data.state === 'invalid') {
                    return data;
                } else {
                    return Promise.all([
                        dispatch('SYNC_SUMMARY', null, { root: true }),
                        dispatch('LOAD_PRODUCTS', null, { root: true }),
                        dispatch('LOAD_CARRIERS_AND_PAYMENTS', null, { root: true })
                    ]);
                }
            });
        },
        remove ({ commit, state, dispatch }, code) {
            const vouchers = {...state.vouchers};
            commit('REMOVE_VOUCHER', code);
            return Api.call({
                action: 'removeVoucher',
                code: code,
                t: new Date().getTime()
            }).then((response) => {
                if (response.ok === false) {
                    commit('SET_VOUCHERS', vouchers);
                }
                return Promise.all([
                    dispatch('SYNC_STATE', null, { root: true }),
                    dispatch('LOAD_CARRIERS_AND_PAYMENTS', null, { root: true })
                ]);
            });
        }
    },
    mutations: {
        SET_VOUCHERS (state, vouchers) {
            state.vouchers = vouchers;
        },
        REMOVE_VOUCHER (state, code) {
            const vouchers = {};
            for (let key in state.vouchers) {
                if (state.vouchers.hasOwnProperty(key) === false) {
                    continue;
                }
                if (state.vouchers[key].code === code) {
                    continue;
                }
                vouchers[key] = state.vouchers[key];
            }
            state.vouchers = vouchers;
        }
    }
};

export default VoucherModule;